import Evaluator, { EvaluatorContext } from "./evaluator/Evaluator"
import EvaluatorFactory from "./evaluator/EvaluatorFactory"
import EvaluateRequest from "./EvaluateRequest"
import EvaluateResponse from "./EvaluateResponse"
import ExperimentEvaluateRequest from "./service/experiment/ExperimentEvaluateRequest"
import ExperimentEvaluateResponse from "./service/experiment/ExperimentEvaluateResponse"
import RemoteConfigEvaluateRequest from "./service/remoteconfig/RemoteConfigEvaluateRequest"
import RemoteConfigEvaluateResponse from "./service/remoteconfig/RemoteConfigEvaluateResponse"
import { InAppMessageEligibilityEvaluateRequest } from "./service/inappmessage/eligibility/InAppMessageEligibilityEvaluateRequest"
import { InAppMessageEligibilityEvaluateResponse } from "./service/inappmessage/eligibility/InAppMessageEligibilityEvaluateResponse"
import { InAppMessageLayoutEvaluateRequest } from "./service/inappmessage/layout/InAppMessageLayoutEvaluateRequest"
import { InAppMessageLayoutEvaluateResponse } from "./service/inappmessage/layout/InAppMessageLayoutEvaluateResponse"

export default class EvaluateProcessor {
  constructor(private readonly evaluatorFactory: EvaluatorFactory) {}

  experiment(request: ExperimentEvaluateRequest): ExperimentEvaluateResponse {
    const evaluator = this.evaluatorFactory.experiment(request)
    return this.evaluate(evaluator, request)
  }

  remoteConfig(request: RemoteConfigEvaluateRequest): RemoteConfigEvaluateResponse {
    const evaluator = this.evaluatorFactory.remoteConfig(request)
    return this.evaluate(evaluator, request)
  }

  inAppMessageEligibility(request: InAppMessageEligibilityEvaluateRequest): InAppMessageEligibilityEvaluateResponse {
    const evaluator = this.evaluatorFactory.inAppMessageEligibility(request)
    return this.evaluate(evaluator, request)
  }

  inAppMessageLayout(request: InAppMessageLayoutEvaluateRequest): InAppMessageLayoutEvaluateResponse {
    const evaluator = this.evaluatorFactory.inAppMessageLayout(request)
    return this.evaluate(evaluator, request)
  }

  private evaluate<REQ extends EvaluateRequest, RESP extends EvaluateResponse>(
    evaluator: Evaluator<REQ, RESP>,
    request: REQ
  ): RESP {
    const response = evaluator.evaluate(request, EvaluatorContext.create())
    if (request.record) {
      evaluator.record(request, response)
    }
    return response
  }
}
